import React from "react";
import { useNavigate } from "react-router";
import { styled } from "@linaria/react";
import { css } from "@linaria/core";
import cn from "classnames";

import Menu from "@ui/Menu";
import Option from "@ui/Option";
import t from "../../../i18n";
import { ArrowDownSLine } from "@ui/IconV2/react";
import Text from "@ui/Text";
import { toPath, useMatchPattern } from "../../../router/helpers/path";

const ZRotate = css`
  transform: rotateZ(180deg);
`;

const MenuTitle = styled.div`
  align-items: center;
  column-gap: 8px;
  display: flex;
  margin-top: 8px;
  height: 32px;
  justify-content: space-between;
  min-width: 125px;
  cursor: pointer;

  svg {
    transition: transform 0.2s ease-in-out;
  }
`;

export const ReportingHeaderMenu = () => {
  const navigate = useNavigate();
  const [menuOpened, setMenuOpened] = React.useState(false);
  const isPerformance = useMatchPattern("/reporting/performance");
  const isDiagnosis = useMatchPattern("/reporting/diagnosis");
  const title = isDiagnosis
    ? t("reporting.page.diagnosis")
    : isPerformance
      ? t("reporting.page.performance")
      : t("reporting.header.title");

  return (
    <Menu
      arrowWidth={0}
      //   gap={1}
      opened={menuOpened}
      setOpened={setMenuOpened}
      overlay={
        <>
          <Option
            selected={location.pathname === "/reporting/performance"}
            closeOnClick
            onClick={() => navigate(toPath("/reporting/performance", {}))}
          >
            {t("reporting.page.performance")}
          </Option>
          <Option
            selected={location.pathname === "/reporting/diagnosis"}
            closeOnClick
            onClick={() => navigate(toPath("/reporting/diagnosis", {}))}
          >
            {t("reporting.page.diagnosis")}
          </Option>
        </>
      }
    >
      <MenuTitle>
        <Text as="p" type="h4">
          {title}
        </Text>
        <ArrowDownSLine className={cn({ [ZRotate]: menuOpened })} />
      </MenuTitle>
    </Menu>
  );
};
